'use strict';

var createClient = require('./client');
var createServer = require('./server');

module.exports = {
  createServer: createServer,
  createClient: createClient
};


//////////////////
// WEBPACK FOOTER
// ../~/boiler-room-runner/dist/index.js
// module id = 644
// module chunks = 0